<template>
  <div class="d-flex justify-content-center align-items-center min-vh-100">
    <div class="text-center">
      <!-- Affichage si NO_LOGIN n'est pas activé -->
      <div v-if="!noLoginEnabled && !loading" class="alert alert-info">
        <h4>Page non disponible</h4>
        <p>Cette page n'est disponible qu'en mode connexion externe.</p>
        <router-link to="/" class="btn btn-primary">
          Retour à l'accueil
        </router-link>
      </div>

      <!-- Affichage normal si NO_LOGIN est activé -->
      <div v-if="noLoginEnabled && loading" class="mb-4">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Chargement...</span>
        </div>
        <h4 class="mt-3">Connexion en cours...</h4>
        <p class="text-muted">
          Veuillez patienter pendant la vérification de votre token.
        </p>
      </div>

      <div v-if="noLoginEnabled && error" class="alert alert-danger">
        <h4>Erreur de connexion</h4>
        <p>{{ errorMessage }}</p>
        <router-link to="/" class="btn btn-primary">
          Retour à l'accueil
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Redirect",
  data() {
    return {
      loading: true,
      error: false,
      errorMessage: ""
    };
  },
  computed: {
    noLoginEnabled() {
      return (
        process.env.VUE_APP_NO_LOGIN === "1" ||
        process.env.VUE_APP_NO_LOGIN === "2"
      );
    }
  },
  async mounted() {
    // Ne rien faire si VUE_APP_NO_LOGIN n'est pas égal à "1"
    if (
      process.env.VUE_APP_NO_LOGIN !== "1" &&
      process.env.VUE_APP_NO_LOGIN !== "2"
    ) {
      this.loading = false;
      return;
    }

    await this.handleTokenLogin();
  },
  methods: {
    async handleTokenLogin() {
      try {
        // Récupérer les paramètres de l'URL
        const token = this.$route.query.token;
        const email = this.$route.query.email;

        if (!token || !email) {
          this.showError("Token ou email manquant dans l'URL");
          return;
        }

        // Appeler l'API /logintoken
        const response = await this.$http.post("/logintoken", {
          email: email,
          token: token
        });

        console.log("Réponse API /logintoken:", response);

        [
          "id",
          "collaborateur_nom",
          "collaborateur_prenom",
          "collaborateur_email_pro",
          "collaborateur_avatar",
          "password_changed",
          "qwark_manager",
          "objectif_mensuel_animations"
        ];

        if (response.status === 200) {
          // Connexion réussie, traiter comme un login classique
          if (response.data.access_token) {
            // Stocker toutes les données dans localStorage comme pour un login normal
            localStorage.setItem("connected", true);
            localStorage.setItem("token", response.data.access_token);
            localStorage.setItem("user_id", response.data.id);
            localStorage.setItem(
              "name",
              response.data.collaborateur_nom +
                " " +
                response.data.collaborateur_prenom
            );
            localStorage.setItem(
              "email",
              response.data.collaborateur_email_pro
            );
            localStorage.setItem(
              "avatar",
              response.data.collaborateur_avatar || ""
            );
            localStorage.setItem(
              "users",
              JSON.stringify(response.data.users || [])
            );
            localStorage.setItem(
              "user_roles",
              JSON.stringify(response.data.user_roles || [])
            );
            localStorage.setItem(
              "user_permissions",
              JSON.stringify(response.data.user_permissions || [])
            );
            localStorage.setItem(
              "password_changed",
              response.data.password_changed || true
            );

            // Forcer le rechargement de la page pour que Vuex relise le localStorage
            // Vérifier s'il y a un paramètre redirect pour la redirection
            const redirectUrl = this.$route.query.redirect || "/";
            window.location.href = redirectUrl;
          } else {
            this.showError("Données de connexion invalides");
          }
        } else {
          this.showError("Erreur de connexion");
        }
      } catch (error) {
        console.error("Erreur lors de la connexion par token:", error);

        if (error.response) {
          switch (error.response.status) {
            case 401:
              this.showError("Token invalide ou expiré");
              break;
            case 404:
              this.showError("Utilisateur non trouvé");
              break;
            case 422:
              this.showError("Données invalides");
              break;
            default:
              this.showError("Erreur de connexion");
          }
        } else {
          this.showError("Erreur de réseau");
        }
      }
    },

    showError(message) {
      this.loading = false;
      this.error = true;
      this.errorMessage = message;
    }
  }
};
</script>

<style scoped>
.min-vh-100 {
  min-height: 100vh;
}
</style>
